export const initialAbility = [
    {
        subject: 'auth',
    }
]

export const _ = undefined
